/**
 * Renderar strukturerad data (JSON-LD) i sidans innehåll i stället för i head().
 * Head-koden kan inte kodsplittas, så stora innehållsfiler som bara behövs för
 * schema.org hamnade tidigare i startsidans bundle. Google läser JSON-LD var
 * som helst i dokumentet, så detta ger samma SEO men mycket mindre startladdning.
 */
export function JsonLd({ scripts }: { scripts: { children: string }[] }) {
  return (
    <>
      {scripts.map((script, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: script.children }}
        />
      ))}
    </>
  );
}
